var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.name},[_c('div',{staticClass:"headline header-title",on:{"click":_vm.onClick}},[_c('span',{staticClass:"font-weight-black",staticStyle:{"color":"#ffa12e"}},[_vm._v("P")]),_c('span',{staticClass:"font-weight-black",staticStyle:{"color":"#707070"}},[_vm._v("icMeter")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }